import React from 'react';
import { Alert } from 'react-bootstrap';
import { ContainerTabContent } from '../../../common-components/TabMenu/styles';
import ServicesContext from '../../../contexts/ServicesContext';
import { strings } from '../../../resources/strings';
import { InternalCommunicationType } from '../../../enums/InternalCommunicationType';
import { InternalCommunicationLog } from '../../../models/InternalCommunicationLog';
import { CardInternalCommunication } from '../CardInternalCommunication/CardInternalCommunication';

interface ITabInternalCommunicationProps {
  orderId?: number;
}

const TabInternalCommunication: React.FC<ITabInternalCommunicationProps> = ({
  orderId
}) => {

  const [internalCommunicationLog, setInternalCommunicationLog] = React.useState<InternalCommunicationLog[]>([]);

  React.useEffect(() => {
    getInternalCommunicationLog();
  }, [orderId]);

  const {
    getInternalCommunicationByOrderService
  } = React.useContext(ServicesContext);

  const memoCommunications = React.useMemo(() => {

    const orderHasAnyInternalCommunication = internalCommunicationLog?.length > 0;

    if (!orderHasAnyInternalCommunication) {
      return (
        <Alert variant='warning' style={{ marginBottom: '0px' }}>
          {strings.NoneInternalCommunicationFound}
        </Alert>
      );
    }

    return internalCommunicationLog.map(communication => {
      return (
        <CardInternalCommunication
          key={`internal-communication-${communication.id}`}
          communication={communication}
        />
      );
    });
  }, [internalCommunicationLog]);

  return (
    <ContainerTabContent maxHeight='60vh'>
      {memoCommunications}
    </ContainerTabContent>
  );

  function getInternalCommunicationLog() {
    if (!orderId) return;

    getInternalCommunicationByOrderService.handle({ orderId, internalCommunicationType: InternalCommunicationType.CarrierStatusAlert })
      .then(result => {
        setInternalCommunicationLog(result?.value?.internalCommunicationLog || []);
      });
  }
}

export { TabInternalCommunication };